import { Country } from '../../types';

export const mapBipsToObsCountries = (bipsProduct): Country => {
  const insuredAmount =
    bipsProduct?.deposit_taking_bank?.statutory_deposit_guarantee_scheme?.insured_amount;
  const branchCountry = bipsProduct?.deposit_taking_bank?.branch_country;
  const countryCode = branchCountry?.id;
  const uniqueCountryId = branchCountry?.unique_country_id;

  return {
    id: countryCode,
    country_code: uniqueCountryId,
    name: branchCountry?.name,
    description: branchCountry?.description,
    source_tax_description: branchCountry?.source_tax_description,
    credit_rating: branchCountry?.rating,
    deposit_guarantee_amount: insuredAmount,
  };
};

export const mapBipsToObsProductOffersForCountries = (bipsProducts): Country[] => {
  const countriesMap = new Map<string, Country>();

  bipsProducts.entries.forEach((product) => {
    const countryId = product?.deposit_taking_bank?.branch_country?.id;

    if (!!countryId && !countriesMap.has(countryId)) {
      countriesMap.set(countryId, mapBipsToObsCountries(product));
    }
  });

  return Array.from(countriesMap.values());
};
